import { Field, RadioGroup } from 'Components/Core';
import withInjectedProps from 'Components/Core/InjectedPropsContext/withInjectedProps';
import ListFieldSection from 'Components/Layout/FieldSection/ListFieldSection';
import { IWorksheetComponent } from 'Components/Worksheets/Core';
import React from 'react';
import { MaterialDriedBy, OversizeMaterialRemovedBy } from '../../types';

let AsPreparationDrySection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  return (
    <>
      <ListFieldSection heading="Dry Preparation">
        <Field
          input={<RadioGroup />}
          name="MaterialDriedBy"
          options={[
            { label: 'Air drying', value: MaterialDriedBy.Air },
            { label: 'Oven drying', value: MaterialDriedBy.Oven },
          ]}
        ></Field>

        <Field
          input={<RadioGroup />}
          name="PreparationProcessingMethod"
          options={[OversizeMaterialRemovedBy.Mortar_Pestle, OversizeMaterialRemovedBy.Mechanical].map((e) => ({
            label: e,
            value: e,
          }))}
        ></Field>
      </ListFieldSection>
    </>
  );
};

AsPreparationDrySection = withInjectedProps(AsPreparationDrySection);

export { AsPreparationDrySection };
export default AsPreparationDrySection;
